<template>
	<div class="chat-link-message" :class="bgClass">
		<span>{{data.filename}}</span>
		<a :href="data.url" target="_blank">查看详情</a>
	</div>
</template>

<script>
	export default {
		props:{
			data: {
				require:true
			},
			bgClass: {
			  type: String
			},
		},
	}
</script>

<style lang="scss" scoped>
	.chat-link-message {
		display: flex;
		align-items: center;
		font-size: 12px;
		a{
			color: #337EFF;
			margin-left: 5px;
		}
		&.left,&.right {
			padding: 6px 10px;
			border-radius: 4px;
		}
		&.left {
			background-color: #F6F7F9;
		}
		&.right {
			background-color: #EDF5FF;
		}
	}
</style>
